<div class="maintenance-fee-wrapper">
  <div class="title">
    Total Amount: <strong><app-currency-icon [currency]="config?.currency"></app-currency-icon>{{(config?.cart_amount || config?.amount) + config?.paymentDetails?.mandate_fee || 0}}/month</strong>
  </div>
  <div class="subtitle">
    <span>Including mandate maintenance charge</span>
    <mat-icon (click)="open(feesBreakup)">info_outline</mat-icon>
  </div>
</div>


<ng-template #feesBreakup>

  <div class="close" (click)="closePopups()"><em class="material-icons">close</em></div>
  <div class="fees-breakup">
    <div class="hr-line-1"></div>
    <div class="title">Price Breakdown</div>
    <div class="amount-wrapper">
      <div class="text">Contribution</div>
      <div class="amount">
        <app-currency-icon [currency]="config?.currency"></app-currency-icon>{{config?.cart_amount || config?.amount}}
      </div>
    </div>
    <div class="charge-wrapper">
      <div class="text">Mandate maintenance charge</div>
      <div class="amount">
        <app-currency-icon [currency]="config?.currency"></app-currency-icon>{{config?.paymentDetails?.mandate_fee}}
      </div>
    </div>
    <div class="desc">
      Your contributions empower our platform to thrive. A nominal maintenance charge will be  auto-deducted, allowing us to maintain quality services for you.
    </div>
    <div class="hr-line"></div>
    <div class="total-wrapper">
      <div class="text">Total Amount</div>
      <div class="amount">
        <app-currency-icon [currency]="config?.currency"></app-currency-icon>{{(config?.cart_amount || config?.amount) + config?.paymentDetails?.mandate_fee || 0}}/month
      </div>
    </div>

    <div class="payment-button">
      <app-payment-sip-button [config]="config" (btnClick)="onPaymentBtnClick()"></app-payment-sip-button>
    </div>
  </div>

</ng-template>